'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIconStyle = function getIconStyle(_ref) {
  var color = _ref.color,
      size = _ref.size,
      thickness = _ref.thickness,
      blue = _ref.blue;

  if (blue) {
    color = '#2395F3';
  }

  var $color = (0, _tinycolor2.default)(color);
  var $offColor = $color.clone().setAlpha(0.2);

  return {
    borderColor: $offColor,
    borderTopColor: $color,
    width: size,
    height: size,
    borderWidth: thickness
  };
};

var ProgressSpinner = function ProgressSpinner(props) {
  return _react2.default.createElement(
    'div',
    { className: 'ProgressSpinner' },
    _react2.default.createElement('div', { className: 'ProgressSpinner__icon', style: getIconStyle(props) })
  );
};

ProgressSpinner.defaultProps = {
  color: '#fff',
  size: 24,
  thickness: 3
};

ProgressSpinner.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  thickness: _propTypes2.default.number,
  blue: _propTypes2.default.bool
};

exports.default = ProgressSpinner;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ProgressSpinner/index.js
// module id = 52
// module chunks = 0